import React, { useEffect, useState } from 'react';
import styles from './TagGroupModel.module.css';
import close from '../../../../../../assets/Close.svg';
import {
  createTagGroup,
  updateTagGroup,
} from '../../../../../../redux/slices/tagGroupSlice';
import { useDispatch } from 'react-redux';
import { useToast } from '@chakra-ui/react';

const TagGroupModel = ({
  modelTitle,
  liveChannels,
  setIsModel,
  uniqueProjectId,
  selectedGroupId,
  selectedGroupName,
  savedChannels,
}) => {
  const dispatch = useDispatch();
  const [groupName, setGroupName] = useState('');
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // Track Select All state
  const [isAllSelected, setIsAllSelected] = useState(false);
  const toast = useToast();

  const handleSaveModel = (e) => {
    e.preventDefault();
    if (modelTitle === 'Add') {
      const reqBody = {
        projectId: uniqueProjectId,
        groupName: groupName,
        channels: selectedChannels,
      };

      dispatch(createTagGroup(reqBody)).then((result) => {
        if (result.payload.status === 201) {
          toast({
            title:
              result.payload.responseBody.message || 'Created Successfully',
            status: 'success',
            position: 'top-right',
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title:
              result.payload.responseBody.message || '!Something went wrong',
            status: 'error',
            position: 'top-right',
            duration: 5000,
            isClosable: true,
          });
        }
      });
    }

    if (modelTitle === 'Edit') {
      const reqBody = {
        id: selectedGroupId,
        groupName: groupName,
        channels: selectedChannels,
      };
      dispatch(updateTagGroup(reqBody)).then((result) => {
        if (result.payload.status === 200) {
          toast({
            title:
              result.payload.responseBody.message || 'Updated Successfully',
            status: 'success',
            position: 'top-right',
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title:
              result.payload.responseBody.message || '!Something went wrong',
            status: 'error',
            position: 'top-right',
            duration: 5000,
            isClosable: true,
          });
        }
      });
    }
    setIsModel(false);
  };

  useEffect(() => {
    setGroupName(selectedGroupName);
    setSelectedChannels(savedChannels);
  }, []);

  useEffect(() => {
    setIsAllSelected(
      liveChannels?.length > 0 &&
        selectedChannels?.length === liveChannels?.length,
    );
  }, [selectedChannels, liveChannels]);

  // Handle individual channel selection
  const handleChannelChange = (channel) => {
    setSelectedChannels((prevSelectedChannels) => {
      if (prevSelectedChannels.includes(channel)) {
        return prevSelectedChannels.filter((item) => item !== channel); // Deselect channel
      } else {
        return [...prevSelectedChannels, channel]; // Select channel
      }
    });
  };

  // Handle Select All functionality
  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedChannels([]); // Deselect all channels
    } else {
      setSelectedChannels(liveChannels); // Select all channels
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };

  return (
    <div className={styles.model}>
      <div className={styles.container}>
        <div className={styles.headerWrapper}>
          <h2 className={styles.title}>
            {modelTitle === 'Add' ? 'Add' : 'Edit'} Group
          </h2>
          <button className={styles.closeBtn} onClick={() => setIsModel(false)}>
            <img src={close} alt="close" />
          </button>
        </div>
        {/* <input
                    type="text"
                    placeholder="Group Name"
                    className={styles.input}
                    onChange={(e) => setGroupName(e.target.value)}
                    defaultValue={groupName}
                />
                <div className={styles.selectallOption}>
                    <input
                        type="checkbox"
                        checked={isAllSelected} // Check if all channels are selected
                        onChange={handleSelectAllChange}
                    />
                    <label htmlFor="" className={styles.channelLabel}>Select All</label>
                </div>

                {liveChannels?.map((channel, i) => (
                    <div className={styles.channel} key={i}>
                        <input
                            type="checkbox"
                            checked={selectedChannels?.includes(channel)} // Check if this channel is selected
                            onChange={() => handleChannelChange(channel)} // Handle individual selection
                        />
                        <label className={styles.channelLabel}>{channel}</label>
                    </div>
                ))}
                <div className={styles.btnWrapper}>
                    <button className={styles.saveBtn} onClick={handleSaveModel}>
                        save
                    </button>
                </div> */}

        <div className={styles.body}>
          <input
            type="text"
            placeholder="Group Name"
            className={styles.input}
            onChange={(e) => setGroupName(e.target.value)}
            defaultValue={groupName}
          />

          <div className={styles.selectallOption}>
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={handleSelectAllChange}
            />
            <label className={styles.channelLabel}>Select All</label>
          </div>

          <div className={styles.channelList}>
            {liveChannels?.map((channel, i) => (
              <div className={styles.channel} key={i}>
                <input
                  type="checkbox"
                  checked={selectedChannels?.includes(channel)}
                  onChange={() => handleChannelChange(channel)}
                />
                <label className={styles.channelLabel}>{channel}</label>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.btnWrapper}>
          <button className={styles.saveBtn} onClick={handleSaveModel}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TagGroupModel;